import { useQuery } from '@tanstack/react-query';

import { useDevice } from '../../../global/contexts/device/device';

const deviceKeys = {
    capabilities: (host) => ['device', host, 'capabilities'],
    notificationPermission: (host) => ['device', host, 'notification-permission'],
};

// Device state is not server state, but it is async, cacheable and needs
// loading/error handling, so TanStack Query is reused instead of a bespoke
// effect. Neither query requests a permission: they only read current state.
export function useCapabilities() {
    const { bridge } = useDevice();
    return useQuery({
        queryKey: deviceKeys.capabilities(bridge.host),
        queryFn: ({ signal }) => bridge.getCapabilities({ signal }),
        staleTime: 60_000,
        retry: false,
    });
}

export function useNotificationPermission() {
    const { bridge } = useDevice();
    return useQuery({
        queryKey: deviceKeys.notificationPermission(bridge.host),
        queryFn: ({ signal }) => bridge.getNotificationPermission({ signal }),
        staleTime: 0,
        retry: false,
    });
}

export { deviceKeys };
